import Request, { API } from '@/http/'

// 产品信息页
export async function loanDetail (data) {
  const res = await Request.getData(API.loan.loanDetail, data)
  return res.data
}

export async function processInfo () {
  const res = await Request.getData(API.processInfo, {}, true, 'get')
  return res
}

export async function getLink () {
  const res = await Request.getData(API.getLink, {}, true, 'get')
  return res
}
